/**
 * Created by renjie.huang on 2017/12/5.
 */

var route = {
	path: '/retrieve',
	getComponent(nextState, cb) {
		require.ensure(
			[],
			(require) => {
				cb(null, require('../pc/RetrievePsword.js').default)
			},
			'retrieve'
		)
	},
}

export default route



// WEBPACK FOOTER //
// ./src/routes/retrieve.js